module.exports = __webpack_public_path__ + "09576845529c95e51b8de5da252e5ead.svg";